import twogisGif from "../images/gif/2gis.gif"
export const projectsData = [
  {
    title:
      "Спроектировали десктопное приложение SkySpace для\u00A0управления виртуальными машинами и\u00A0администрирования VDI",
    tags: "Десктопное приложение",
  },

  {
    title:
      "Создали мобильную игру для\u00A0Буше\u00A0— сети городских кофеен и\u00A0кондитерских",
    tags: "Мобильное приложение",
  },

  {
    title: "Задизайнили логотип для\u00A0студии разработки Quado",
    tags: "Логотип",
  },

  {
    title: "Провели редизайн Nutrition lab\u00A0— приложения для\u00A0контроля питания",
    tags: "Мобильное приложение",
    loom: "",
  },

  {
    title: "Создали логотип для\u00A0Nutrition lab\u00A0— приложения для\u00A0подсчёта калорий",
    tags: "Логотип",
    loom: "",
  },

  {
    title:
      "Спроектировали мобильное приложение для\u00A0Повоенке\u00A0— сервиса подбора жилья для\u00A0военнослужащих",
    tags: "Логотип",
    loom: "",
  },
  {
    title:
      "Задизайнили логотип для\u00A0Повоенке\u00A0— сервиса подбора жилья для\u00A0военнослужащих",
    tags: "Логотип",
    loom: "",
  },
  {
    title:
      "Задизайнили платформу для\u00A0хранения и\u00A0оптовой торговли рыбной продукцией для\u00A0Fishplace",
    tags: "Сайт",
    loom: "",
  },
  {
    title:
      "Полгода оказывали дизайн-поддержку команде коммуникаций B2B-направления 2ГИС",
    tags: "Коммуникации",
    loom: "",
  },
  {
    title:
      "9\u00A0месяцев помогали Отелло с\u00A0созданием регулярных маркетинговых материалов",
    tags: "Коммуникации",
    loom: "",
  },
  {
    title:
      "Разработали квиз по\u00A0самым-самым местам России для\u00A02ГИС",
    tags: "Сайт, Разработка",
    loom: "",
  },
  {
    title:
      "Сделали нейминг и\u00A0логобук для\u00A0Attiro\u00A0— сервиса по\u00A0подбору одежды",
    tags: "Логотип",
    loom: "",
  },
  {
    title:
      "За\u00A050\u00A0дней запустили Экоиндекс\u00A0— сайт-исследование городов России",
    tags: "Сайт, Разработка",
    loom: "",
  },
  {
    title:
      "Задизайнили сервис по\u00A0составлению винных маршрутов для\u00A0Russian Wine",
    tags: "Сайт",
    loom: "",
  },
  {
    title:
      "Разработали дизайн 7\u00A0проектов для\u00A0сенсорных стендов на\u00A0крупных выставках Gitex, CityScape и\u00A0тд.",
    tags: "Сайт",
    loom: "",
  },
  {
    title:
      "Запустили адвент-календарь для\u00A02GIS, поучаствовали 350,000\u00A0пользователей",
    tags: "Сайт, Разработка",
    loom: "",
  },
  {
    title:
      "Сделали айдентику для\u00A0разработчика отечественных сетевых решений Linki",
    tags: "Айдентика, Логотип, Брендинг",
    loom: "",
  },
  {
    title:
      "1.5\u00A0года развиваем Balady\u00A0— главного конкурента Google-карт в\u00A0Саудовской Аравии",
    tags: "Мобильное приложение",
  },
  {
    title:
      "Сделали дизайн и\u00A0разработали на\u00A0тильде новый сайт 2ГИС",
    tags: "Сайт",
    loom: "https://www.loom.com/share/fbaae457328b4773ac0547e3aef117d1",
    photo: twogisGif,
  },
];
